(function () {
  const theme = window.MustelaTheme || {};
  const wishlistKey = 'mustela-wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(wishlistKey) || '[]'); } catch (error) { return []; }
  }

  function setWishlist(items) {
    localStorage.setItem(wishlistKey, JSON.stringify([...new Set(items)]));
    updateWishlistButtons();
  }

  function updateWishlistButtons() {
    const items = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = items.includes(button.dataset.wishlistToggle);
      button.classList.toggle('active', active);
      button.textContent = active ? '♥' : '♡';
      button.setAttribute('aria-pressed', String(active));
    });
  }

  function formatMoney(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-AE', { style: 'currency', currency: theme.currency || 'AED' }).format(Number(cents) / 100); }
    catch (error) { return `AED ${(Number(cents) / 100).toFixed(2)}`; }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));
  }

  async function refreshCartCount() {
    try {
      const response = await fetch(`${theme.rootUrl || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count || ''; });
    } catch (error) { /* Keep the server-rendered cart count. */ }
  }

  function initHeader(header) {
    if (header.dataset.initialized) return;
    header.dataset.initialized = 'true';
    const menuButton = header.querySelector('.menu-toggle');
    const mobileNav = header.querySelector('.mobile-nav');
    const triggers = [...header.querySelectorAll('.mega-trigger[data-mega-target]')];
    const menus = [...header.querySelectorAll('.mega-menu')];
    const closeMenus = () => {
      menus.forEach((menu) => { menu.classList.remove('open'); menu.setAttribute('aria-hidden', 'true'); });
      triggers.forEach((trigger) => { trigger.classList.remove('active'); trigger.setAttribute('aria-expanded', 'false'); });
    };
    const openMenu = (trigger) => {
      if (window.innerWidth <= 920) return;
      const menu = document.getElementById(trigger.dataset.megaTarget);
      if (!menu) return;
      closeMenus();
      menu.classList.add('open');
      menu.setAttribute('aria-hidden', 'false');
      trigger.classList.add('active');
      trigger.setAttribute('aria-expanded', 'true');
    };
    triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => openMenu(trigger));
      trigger.addEventListener('focus', () => openMenu(trigger));
      
    });
    header.addEventListener('mouseleave', closeMenus);
    document.addEventListener('click', (event) => { if (!header.contains(event.target)) closeMenus(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenus(); });
    menuButton?.addEventListener('click', () => {
      const open = menuButton.classList.toggle('open');
      mobileNav?.classList.toggle('open', open);
      document.body.classList.toggle('menu-open', open);
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    header.querySelectorAll('.mobile-submenu-toggle').forEach((button) => {
      button.addEventListener('click', () => {
        const submenu = button.nextElementSibling;
        const opening = submenu && !submenu.classList.contains('open');
        header.querySelectorAll('.mobile-submenu').forEach((item) => item.classList.remove('open'));
        header.querySelectorAll('.mobile-submenu-toggle').forEach((item) => item.setAttribute('aria-expanded', 'false'));
        if (submenu) submenu.classList.toggle('open', opening);
        button.setAttribute('aria-expanded', String(opening));
      });
    });
  }

  async function addVariant(variantId, quantity, button, message) {
    const original = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    try {
      const response = await fetch(`${theme.cartAddUrl || '/cart/add'}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity || 1) }] }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this product.');
      if (button) button.textContent = '✓';
      if (message) message.textContent = 'Added to your cart.';
      await refreshCartCount();
      window.setTimeout(() => { if (button) { button.innerHTML = original; button.disabled = false; button.removeAttribute('aria-busy'); } }, 1200);
    } catch (error) {
      if (message) message.textContent = error.message;
      if (button) { button.innerHTML = original; button.disabled = false; button.removeAttribute('aria-busy'); }
    }
  }

  function initProductSection(section) {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const zoomArea = section.querySelector('[data-product-zoom]');
    const resetZoom = () => {
      if (!zoomArea) return;
      zoomArea.classList.remove('is-zooming');
      zoomArea.style.removeProperty('--zoom-x');
      zoomArea.style.removeProperty('--zoom-y');
    };
    section.querySelectorAll('[data-product-media-target]').forEach((button) => button.addEventListener('click', () => {
      resetZoom();
      section.querySelectorAll('[data-product-media]').forEach((media) => { const active = media.dataset.productMedia === button.dataset.productMediaTarget; media.hidden = !active; media.classList.toggle('active', active); });
      section.querySelectorAll('[data-product-media-target]').forEach((thumb) => thumb.classList.toggle('active', thumb === button));
    }));
    zoomArea?.addEventListener('pointermove', (event) => {
      if (event.pointerType === 'touch' || !zoomArea.querySelector('.product-media-slide.active > img')) return;
      const bounds = zoomArea.getBoundingClientRect();
      const x = Math.max(0, Math.min(100, ((event.clientX - bounds.left) / bounds.width) * 100));
      const y = Math.max(0, Math.min(100, ((event.clientY - bounds.top) / bounds.height) * 100));
      zoomArea.style.setProperty('--zoom-x', x.toFixed(2) + '%');
      zoomArea.style.setProperty('--zoom-y', y.toFixed(2) + '%');
      zoomArea.classList.add('is-zooming');
    });
    zoomArea?.addEventListener('pointerleave', resetZoom);
    section.querySelectorAll('.product-tab').forEach((button) => button.addEventListener('click', () => {
      section.querySelectorAll('.product-tab').forEach((tab) => { tab.classList.toggle('active', tab === button); tab.setAttribute('aria-selected', String(tab === button)); });
      section.querySelectorAll('.product-tab-panel').forEach((panel) => { const active = panel.id === button.dataset.panel; panel.hidden = !active; panel.classList.toggle('active', active); });
    }));
    const variantSelect = section.querySelector('[data-variant-select]');
    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      section.querySelector('[data-product-price]').textContent = option.dataset.price;
      const comparePrice = section.querySelector('[data-product-compare-price]');
      if (comparePrice) { comparePrice.textContent = option.dataset.comparePrice || ''; comparePrice.hidden = !option.dataset.comparePrice; }
      const selectedVariant = section.querySelector('[data-selected-variant]');
      if (selectedVariant) selectedVariant.textContent = `Selected ${selectedVariant.dataset.optionLabel || 'option'}: ${option.dataset.title}`;
      const buttonPrice = section.querySelector('[data-button-price]');
      if (buttonPrice) buttonPrice.textContent = option.dataset.price;
      const url = new URL(window.location.href); url.searchParams.set('variant', variantSelect.value); window.history.replaceState({}, '', url);
    });
    const form = section.querySelector('[data-product-form]');
    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(form);
      addVariant(data.get('id'), data.get('quantity'), form.querySelector('[data-add-to-cart]'), form.querySelector('[data-product-form-message]'));
    });
    section.querySelectorAll('[data-description-toggle]').forEach((button) => button.addEventListener('click', () => {
      const shell = button.closest('[data-product-description]');
      const preview = shell?.querySelector('[data-description-preview]');
      const full = shell?.querySelector('[data-description-full]');
      if (!preview || !full) return;
      const expanding = !preview.hidden;
      preview.hidden = expanding;
      full.hidden = !expanding;
    }));
  }

  function initAccordions(scope) {
    scope.querySelectorAll('.accordion-button:not([data-initialized])').forEach((button) => {
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => { const item = button.closest('.accordion-item'); const open = item.classList.toggle('open'); button.setAttribute('aria-expanded', String(open)); button.querySelector('span').textContent = open ? '−' : '+'; });
    });
  }

  async function initRecommendations(section) {
    if (section.dataset.loaded || !section.dataset.url) return;
    section.dataset.loaded = 'true';
    try { const response = await fetch(section.dataset.url); const html = await response.text(); const parsed = new DOMParser().parseFromString(html, 'text/html'); const replacement = parsed.querySelector('[data-product-recommendations]'); if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML; }
    catch (error) { section.hidden = true; }
  }

  function initFilters(scope) {
    const drawer = scope.querySelector('[data-filter-drawer]');
    scope.querySelector('[data-filter-open]')?.addEventListener('click', () => drawer?.classList.add('open'));
    scope.querySelector('[data-filter-close]')?.addEventListener('click', () => drawer?.classList.remove('open'));
    scope.querySelector('[data-sort-select]')?.addEventListener('change', (event) => event.target.form.submit());
  }

  async function renderWishlistPage(container) {
    const handles = getWishlist();
    const empty = container.querySelector('[data-wishlist-empty]');
    const productsNode = container.querySelector('[data-wishlist-products]');
    if (!handles.length) return;
    empty.hidden = true;
    const products = await Promise.all(handles.map(async (handle) => { try { const response = await fetch(`${theme.rootUrl || '/'}products/${encodeURIComponent(handle)}.js`); return response.ok ? response.json() : null; } catch (error) { return null; } }));
    productsNode.innerHTML = products.filter(Boolean).map((product) => `<article class="product-card collection-card" data-product-card data-product-handle="${escapeHtml(product.handle)}"><div class="product-image"><button class="heart active" type="button" data-wishlist-toggle="${escapeHtml(product.handle)}" aria-label="Remove ${escapeHtml(product.title)} from wishlist" aria-pressed="true">♥</button><a href="${escapeHtml(product.url)}"><img src="${escapeHtml(product.featured_image)}" loading="lazy" alt="${escapeHtml(product.title)}"></a>${product.available ? `<button class="add-button" type="button" data-quick-add="${product.variants[0].id}" aria-label="Add ${escapeHtml(product.title)} to bag">+</button>` : ''}</div><div class="product-info"><h3><a href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a></h3><p class="price">${formatMoney(product.price)}</p></div></article>`).join('');
    updateWishlistButtons();
  }

  function initAddresses(scope) {
    scope.querySelectorAll('[data-address-toggle]').forEach((button) => button.addEventListener('click', () => { const target = document.getElementById(button.dataset.addressToggle); if (target) target.hidden = !target.hidden; }));
    scope.querySelectorAll('[data-address-delete]').forEach((button) => button.addEventListener('click', (event) => { if (!window.confirm('Are you sure you wish to delete this address?')) event.preventDefault(); }));
    if (window.Shopify?.CountryProvinceSelector) scope.querySelectorAll('select[name="address[country]"]').forEach((country) => { const province = country.closest('form')?.querySelector('select[name="address[province]"]'); if (province) new window.Shopify.CountryProvinceSelector(country.id, province.id, { hideElement: province.parentElement?.id }); });
  }

  function initTheme(scope) {
    scope.querySelectorAll('.site-header').forEach(initHeader);
    scope.querySelectorAll('[data-product-section]').forEach(initProductSection);
    scope.querySelectorAll('[data-product-recommendations]').forEach(initRecommendations);
    scope.querySelectorAll('[data-wishlist-page]').forEach(renderWishlistPage);
    initAccordions(scope);
    initFilters(scope);
    initAddresses(scope);
    updateWishlistButtons();
  }

  if (!document.documentElement.dataset.mustelaEvents) {
    document.documentElement.dataset.mustelaEvents = 'true';
    document.addEventListener('click', (event) => {
      const quickAdd = event.target.closest('[data-quick-add]');
      if (quickAdd) { event.preventDefault(); addVariant(quickAdd.dataset.quickAdd, 1, quickAdd); return; }
      const wishlist = event.target.closest('[data-wishlist-toggle]');
      if (wishlist) { event.preventDefault(); const handle = wishlist.dataset.wishlistToggle; const items = getWishlist(); setWishlist(items.includes(handle) ? items.filter((item) => item !== handle) : [...items, handle]); const card = wishlist.closest('[data-product-card]'); if (document.querySelector('[data-wishlist-page]') && !getWishlist().includes(handle)) card?.remove(); }
    });
    document.addEventListener('change', (event) => { if (event.target.matches('[data-localization-select]')) event.target.form.submit(); });
    document.addEventListener('shopify:section:load', (event) => initTheme(event.target));
  }

  document.addEventListener('DOMContentLoaded', () => initTheme(document));
  window.addEventListener('load', () => initAddresses(document));
})();